import PropTypes from 'prop-types';
import { memo, useMemo } from 'react';
import { useSelector } from 'react-redux';
import I18n from 'I18n';
import MultiFilterSelect from './MultiFilterSelect';
import { jsx as _jsx } from "react/jsx-runtime";
function LanguageSelect(props) {
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'zorseTicketInspector' does not exist on ... Remove this comment to see the full error message
  const languageOptions = useSelector(({
    zorseTicketInspector
  }) => zorseTicketInspector.filterOptions.languages.toArray());

  // @ts-expect-error ts-migrate(2339) FIXME: Property 'zorseTicketInspector' does not exist on ... Remove this comment to see the full error message
  const languages = useSelector(({
    zorseTicketInspector
  }) => zorseTicketInspector.filters.languages.toArray());
  const options = useMemo(() => languageOptions.map(value => ({
    text: I18n.text(`app.filter.panel.language.options.${value}`),
    value
  })).sort((a, b) => a.text.localeCompare(b.text)), [languageOptions]);
  return /*#__PURE__*/_jsx(MultiFilterSelect, {
    "data-test-id": "filter-select",
    defaultValue: languages,
    labelLangPath: "app.filter.panel.language.label",
    onSelect: props.onSelect,
    options: options,
    placeholderLangPath: "app.filter.panel.language.placeholder"
  });
}
LanguageSelect.propTypes = {
  onSelect: PropTypes.func.isRequired
};
export default /*#__PURE__*/memo(LanguageSelect);